import ErrorAPI from "helpers/api";
import { customSecuredApi } from ".";
import Config from "../Config";

export type ChatHistoryMessage = {
  role: "user" | "assistant";
  content: string;
};

export type ChatReply = {
  reply: string;
  disabled: boolean;
};

export type ChatQuestionLog = {
  id: string;
  userId: string;
  userName?: string | null;
  role: string;
  question: string;
  createdAt: string;
  inputTokens: number;
  outputTokens: number;
  cacheReadTokens: number;
  cacheWriteTokens: number;
};

export type ChatQuestionLogPage = {
  items: ChatQuestionLog[];
  totalCount: number;
};

export type GetChatLogsParams = {
  role?: string;
  sortBy?: string;
  sortDir?: "asc" | "desc";
  pageNumber: number;
  pageSize: number;
};

export const sendChatMessage = async (
  message: string,
  history: ChatHistoryMessage[]
): Promise<ChatReply> => {
  const { payload, body } = await customSecuredApi.call<ChatReply>({
    method: "POST",
    path: Config.apis.chat.message,
    body: { message, history },
  });

  if (payload.ok && body) {
    return body;
  }

  throw new ErrorAPI(payload.status, body);
};

export const getChatLogs = async (
  params: GetChatLogsParams
): Promise<ChatQuestionLogPage> => {
  const qs = new URLSearchParams();
  if (params.role) qs.set("role", params.role);
  if (params.sortBy) qs.set("sortBy", params.sortBy);
  if (params.sortDir) qs.set("sortDir", params.sortDir);
  qs.set("pageNumber", String(params.pageNumber));
  qs.set("pageSize", String(params.pageSize));

  const { payload, body } = await customSecuredApi.call<ChatQuestionLogPage>({
    method: "GET",
    path: `${Config.apis.chat.logs}?${qs.toString()}`,
  });

  if (payload.ok && body) {
    return body;
  }

  throw new ErrorAPI(payload.status, body);
};
